import { FC } from 'react';
import Link from 'next/link';
import { Content } from '@components/layouts';
import { useScreen } from '@shared/helpers/screen.helper';
import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
import { BgTrans, Box, Container, Detail, Inside, Title } from './BottomMenu.style';
const BottomMenu: FC = () => {
  const {
    isMobile
  } = useScreen();
  const cardListInfo = [{
    title: 'ผลิตภัณฑ์ซีพี',
    description: <span>
                    อาหารคุณภาพ
                    <br />
                    เติมชีวิตที่ดี
                </span>,
    mobileDescription: <span>อาหารคุณภาพ เติมชีวิตที่ดี</span>,
    bgImage: '/images/bottom-menu/bottom-menu-product.jpg',
    linkOut: '/product'
  }, {
    title: 'เคล็ดลับฉบับซีพี',
    description: <span>
                    เคล็ดลับดีๆ
                    <br />
                    ที่ซีพีอยากมอบให้คุณ
                </span>,
    mobileDescription: <span>เคล็ดลับดีๆ ที่ซีพีอยากมอบให้คุณ</span>,
    bgImage: '/images/bottom-menu/bottom-menu-tip.jpg',
    linkOut: '/tips-tricks'
  }, {
    title: 'ค้นหาเมนูซีพี',
    description: <span>
                    ยังมีไอเดียเมนูอีกมากมาย
                    <br />
                    รอให้คุณได้ค้นพบ
                </span>,
    mobileDescription: <span>
                    ยังมีไอเดียเมนูอีกมากมาย
                    <br />
                    รอให้คุณได้ค้นพบ
                </span>,
    bgImage: '/images/bottom-menu/bottom-menu-recipe.jpg',
    linkOut: `/search?c=${ModuleType.Recipe}`
  }];
  const onClick = (title: string) => {
    analytics.track('Widget Click', {
      event: 'Widget Click',
      widget_name: title
    });
  };
  return <Content>
            <Container>
                {cardListInfo.map(({
        title,
        description,
        bgImage,
        linkOut,
        mobileDescription
      }, index) => {
        return <Link href={linkOut} key={index} onClick={() => onClick(title)}>
                                <Box $bgImage={bgImage}>
                                    <Inside>
                                        <Title>{title}</Title>
                                        <Detail>
                                            {isMobile ? mobileDescription : description}
                                        </Detail>
                                    </Inside>
                                    <BgTrans />
                                </Box>
                            </Link>;
      })}
            </Container>
        </Content>;
};
export default BottomMenu;